// HotLeadFilter.js
import React, { useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";

const HotLeadFilter = ({
  visible,
  onHide,
  selectedCountLead,
  setSelectedCountLead,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  getLocalDate,
  handleApplyFilter,
  clearFilters,
}) => {
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");

  const formatDisplayDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };


  return (
    <Sidebar
      header={<div className="flex align-items-center gap-2"><span className="font-bold">Filter</span></div>}
      visible={visible}
      onHide={onHide}
      position="right"
      className="w-full md:w-1/3"
    >
      <div className="flex flex-col gap-4 p-4">
       
       {/* Count Filter */}
       <div className="w-full border-2 cursor-pointer border-customGreen rounded-md">
          <select
            className="w-full p-2 rounded-md focus:outline-none"
            value={selectedCountLead}
            onChange={(e) => setSelectedCountLead(parseInt(e.target.value, 10))}
          >
            <option value="">Select count</option>
            {Array.from({ length: 10 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        {/* Start Date */}
        <div className="w-full border-2 border-customGreen rounded-md">
          <input
            type={startType}
            onFocus={() => setStartType("date")}
            onBlur={() => setStartType("text")}
            placeholder="Start Date"
            className="appearance-none cursor-pointer w-full shadow border rounded py-2 px-3 text-gray-700"
            value={startType === "text" ? formatDisplayDate(startDate) : startDate}
            max={getLocalDate()}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        {/* End Date */}
        <div className="w-full border-2 border-customGreen rounded-md">
          <input
            type={endType}
            onFocus={() => setEndType("date")}
            onBlur={() => setEndType("text")}
            placeholder="End Date"
            required={startDate}
            className="appearance-none cursor-pointer w-full shadow border rounded py-2 px-3 text-gray-700"
            value={endType === "text" ? formatDisplayDate(endDate) : endDate}
            min={startDate}
            max={getLocalDate()}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        {/* Buttons */}
        <button
          className="bg-customGreen text-white py-2 px-4 rounded-md hover:bg-appGreenHover transition duration-300 w-full mt-4"
          onClick={handleApplyFilter}
        >
          Apply Filters
        </button>
        <button
          className="bg-white text-customGreen border border-customGreen py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
          onClick={clearFilters}
        >
          Clear Filters
        </button>
      </div>
    </Sidebar>
  );
};

export default HotLeadFilter;